module.exports = __webpack_public_path__ + "5651e4275fd08c63ea9caa93743f9c04.jpg";